'use client'

import { useContext, useEffect, useState } from 'react'

import { Checkbox } from 'ariakit/checkbox'
import cn from 'clsx'
import type { TextProps } from '@/components/Text/Text'
import { Text } from '@/components/Text/Text'
import { ThemeContext } from '@/utils/themeContext'
import { type Themes, themes as Theme } from '@/Theme'

import CheckMark from './checkmark.svg?react'

import css from './marketing-checkbox-field.module.css'

export type MarketingCheckboxFieldProps = {
    label: string
    /**
     * @deprecated: use ThemeProvider instead
     * */
    theme?: Themes
    checked?: boolean
    className?: string
    onChange?: (checked: boolean) => void
    disabled?: boolean
    exceptionallySetTextProperties?: TextProps
}

export function MarketingCheckboxField({
    label,
    theme: deprecatedTheme = Theme.todoist,
    checked = false,
    onChange,
    className,
    disabled,
    exceptionallySetTextProperties,
    ...rest
}: MarketingCheckboxFieldProps) {
    const { theme = deprecatedTheme } = useContext(ThemeContext)
    const [privateChecked, setPrivateChecked] = useState(checked)

    useEffect(() => {
        setPrivateChecked(checked)
    }, [checked])

    const internalOnChange = () => {
        if (onChange) onChange(!privateChecked)
        setPrivateChecked(!privateChecked)
    }

    return (
        <Text
            tag="label"
            className={cn(css.marketingCheckboxField, css[theme], className)}
            size={theme === 'twist' ? 'minor-sm' : 'body-sm'}
            {...exceptionallySetTextProperties}
            {...rest}
        >
            <Checkbox checked={privateChecked} onChange={internalOnChange} disabled={disabled} />
            <span className={css.checkmark}>{privateChecked && <CheckMark />}</span>
            {label}
        </Text>
    )
}
